<template>
  <router-view />
</template>

<script>
export default {
  name: 'SafariDriversIndex'
}
</script>
